import { Container, Row, Col, Card, Button, Image } from "react-bootstrap";
import { FaBullseye, FaRocket, FaEye } from "react-icons/fa";
import mainLogo from "../assets/mainLogo.png";
import Meghna from "../assets/Meghna.webp";
import Arun from "../assets/Arun.webp";
import tej from "../assets/Tej.webp";
import { Helmet } from "react-helmet";
import {
  FaWhatsapp,
  FaLinkedin,
  FaFacebook,
  FaInstagram,
  FaPhone,
} from "react-icons/fa";
import axios from 'axios';
import { useEffect } from "react";

const AboutUs = () => {

  useEffect(() => {
      wakeUpAPI();
    }, []);
  
    const wakeUpAPI = async () => {
      try {
        const response = await axios.get('https://sfa-blog.onrender.com/api/blogs?page=1&limit=1');
        // console.log('API woke up:', response.status);
      } catch (error) {
      }
  };
  
  return (
    <section className="py-5 bg-light">
      <Helmet>
        <title>
          Shatrunjay Financial Advisors | Financial Advisors in Mumbai & Kalyan-Dombivli | Wealth Planning
        </title>
        <meta
          name="description"
          content="Trusted financial advisors in Mumbai & Kalyan-Dombivli. Expert tax saving, SIP, insurance & wealth planning. Book your free consultation today!"
        />
      </Helmet>
      {/* Heading */}
      <Container fluid className="d-flex justify-content-center mb-5">
        <Card
          className="text-center shadow-lg border-0 w-100"
          style={{
            background:
              "linear-gradient(135deg, #3a0063 0%,rgb(137, 31, 212) 100%)",
            color: "#feca0a",
            borderRadius: "15px",
            padding: "60px 20px",
            minHeight: "250px",
          }}
        >
          <Container>
            <h2 className="mb-3 fw-bold display-4">About Us</h2>
            <p className="fs-4">You Trust. We Care. You Prosper.</p>
            <hr
              style={{
                width: "60px",
                margin: "20px auto",
                border: "3px solid white",
              }}
            />
          </Container>
        </Card>
      </Container>
      <Container>
        {/* Objectives, Mission, Vision */}
        <Row className="mt-5 pl-5">
          {[
            {
              icon: (
                <FaBullseye className=" fs-1" style={{ color: "#3A0063" }} />
              ),
              title: "Objective",
              description:
                "We guide our customers through structured financial planning, ensuring a step-by-step path to success and prosperity.",
            },
            {
              icon: <FaRocket className=" fs-1" style={{ color: "#3A0063" }} />,
              title: "Mission",
              description:
                "Our mission is to empower clients with smart investment strategies, ensuring a secure and prosperous financial future.",
            },
            {
              icon: <FaEye className="fs-1" style={{ color: "#3A0063" }} />,
              title: "Vision",
              description:
                "We envision a future where individuals achieve financial independence and enjoy a stress-free retirement through smart planning.",
            },
          ].map((item, index) => (
            <Col md={4} key={index}>
              <Card className="shadow-sm border-0 text-center p-4 h-100 custom-card">
                <div className="mb-3">{item.icon}</div>
                <h5 className="fw-bold">{item.title}</h5>
                <p className="text-muted">{item.description}</p>
              </Card>
            </Col>
          ))}
        </Row>

        {/* About Shatrunjay Financial Advisors */}
        <section className="about-section py-5">
          {/* <Container> */}
          <div className="about-card shadow-lg rounded p-4 d-flex align-items-center">
            {/* Image Positioned Left */}
            <div className="about-image">
              <Image
                src={mainLogo}
                alt="Shatrunjay Financial Advisors"
                className="img-fluid"
              />
            </div>

            {/* Text Content */}
            <div className="about-content ps-md-4">
              <h2 className="fw-bold mb-3" style={{ color: "#3A0063" }}>
                About Shatrunjay Financial Advisors
              </h2>
              <p className="text-muted fs-5">
                At <strong>Shatrunjay Financial Advisors</strong>, we guide our
                clients towards a financially secure future. Our{" "}
                <strong>proven financial strategies</strong> help individuals
                and businesses achieve long-term success.
              </p>
              <p className="text-muted fs-5">
                With{" "}
                <span className="text-success fw-bold">
                  50+ industry-leading professionals
                </span>{" "}
                and an extensive track record of financial planning success, we
                deliver <strong>tailored solutions</strong> that ensure
                financial growth and security.
              </p>
              <Button
                className="mt-3 px-4 py-2 shadow-sm"
                style={{ backgroundColor: "#3A0063" }}
              >
                Discover More
              </Button>
            </div>
          </div>
          {/* </Container> */}
        </section>

        {/* Our Team */}
        <section className="mt-5 mb-5">
          <h2 className="fw-bold mb-3 text-center" style={{ color: "#3A0063" }}>
            Our Team
          </h2>
          {/* <Container> */}
          <Row className="gy-4">
            {[
              {
                name: "Meghna Dhulla",
                role: "Chief Life Insurance Advisor & Financial Consultant in Mumbai & Kalyan-Dombivli",
                image: Meghna,
                description:
                  "Founder of Shatrunjay Financial Advisors, Meghna Dhulla has 18+ years of expertise as a financial consultant, insurance advisor, and wealth planner. She helps families secure their future with custom life insurance and investment solutions.",
                igUrl: "https://www.instagram.com/meghna_dhulla?igsh=MXFscjlmNThhbmlzMg==",
                linkediNuRL: "https://www.linkedin.com/in/meghna-dhulla-15aa55148?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
                fbUrl:"https://www.facebook.com/share/1F9XKDQmiv/",
                contactNumber: "9892937740",
                imageAlt:"Meghna Dhulla – Financial Consultant and Life Insurance Advisor in Mumbai & Kalyan-Dombivli",
              },
              {
                name: "Arun Dhulla",
                role: "CEO | Certified Financial Advisor & Wealth Management Expert",
                image: Arun,
                igUrl: "https://www.instagram.com/arun_dhulla?igsh=MWdiMG9sYXd2bnV0aA==",
                linkediNuRL: "https://www.linkedin.com/in/arun-dhulla-40157a38?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
                fbUrl:"https://www.facebook.com/share/1FEABhEiGo/",
                contactNumber: "7715880775",
                imageAlt:"Arun Dhulla – Certified Financial Advisor and Wealth Planner in Mumbai",
                description:
                  "With an MBA in Finance and 21 years in banking and financial planning, Arun Dhulla is a trusted financial advisor, investment consultant, and retirement planner for clients in Mumbai & Kalyan-Dombivli.",
              },
              {
                name: "Tej Dhulla",
                role: "Relationship Manager | Client Support for Financial Services",
                image: tej,
                igUrl: "https://www.instagram.com/tejdhulla_6340?igsh=MWkxdmtndWIwM2toYQ==",
                linkediNuRL: "https://www.linkedin.com/in/tej-dhulla-b76654190?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
                fbUrl:"https://www.facebook.com/share/1Aj6vwjKCk/",
                contactNumber: "9967530074",
                description:
                  "Tej Dhulla provides exceptional customer support for insurance, SIPs, tax-saving plans, and mutual fund investments. He assists clients in achieving financial security with trusted advisor-backed solutions.",
                imageAlt:"Tej Dhulla – Financial Services Relationship Manager in Mumbai and Kalyan-Dombivli",
              },
            ].map((member, index) => (
              <Col md={4} key={index}>
                <Card className="team-card border-0 shadow-sm">
                  <div className="image-wrapper">
                    <Card.Img
                      variant="top"
                      src={member.image}
                      alt={member.imageAlt}
                      className="rounded-top"
                    />
                  </div>
                  <Card.Body className="d-flex flex-column">
                    <h5 className="text-center fw-bold">{member.name}</h5>
                    <p className="text-center text-muted">{member.role}</p>
                    <p className="text-muted flex-grow-1">
                      {member.description}
                    </p>
                    <Col md={12} className="text-center text-md-center">
                      <div className="d-flex flex-wrap justify-content-center justify-content-center align-items-center gap-2">
                        <Button
                          variant="outline-primary"
                          href={`tel:${member.contactNumber}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            border: "1px solid #3A0063", // Customize style, color, thickness
                            borderRadius: "8px", // Optional: rounded corners
                          }}
                        >
                          <FaPhone style={{ color: "#3A0063" }} />
                        </Button>
                        <Button
                          variant="outline-primary"
                          href={`https://wa.me/91${member.contactNumber}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            border: "1px solid #3A0063", // Customize style, color, thickness
                            borderRadius: "8px", // Optional: rounded corners
                          }}
                        >
                          <FaWhatsapp style={{ color: "#3A0063" }} />
                        </Button>
                        <Button
                          variant="outline-primary"
                          href={member.linkediNuRL}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            border: "1px solid #3A0063", // Customize style, color, thickness
                            borderRadius: "8px", // Optional: rounded corners
                          }}
                        >
                          <FaLinkedin style={{ color: "#3A0063" }} />
                        </Button>
                        <Button
                          variant="outline-primary"
                          href={member.fbUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            border: "1px solid #3A0063", // Customize style, color, thickness
                            borderRadius: "8px", // Optional: rounded corners
                          }}
                        >
                          <FaFacebook style={{ color: "#3A0063" }} />
                        </Button>
                        <Button
                          variant="outline-primary"
                          href={member.igUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            border: "1px solid #3A0063", // Customize style, color, thickness
                            borderRadius: "8px", // Optional: rounded corners
                          }}
                        >
                          <FaInstagram style={{ color: "#3A0063" }} />
                        </Button>
                      </div>
                    </Col>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          {/* </Container> */}
        </section>
      </Container>
    </section>
  );
};

export default AboutUs;
